import { lazy } from 'react';

export const AttributesCategoriesPage = lazy(() => import('./AttributesCategoriesPage'));
